import { TouchableOpacity, View } from 'react-native';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import Constant from './tdsRedux/Constant';
import { backgroundTdsArr, backgroundTdsArrBackPage } from './backgroundTdsArr';
import getPlatformType from '../../helpers/getPlatform';
import { navigateAction, popAction } from '../../helpers/navigationHelpers';
import { Container, ButtonWrapper, Typography, BoxShadow } from './style';
import BackGroundGenerator from '../LandingPages/common/BackGroundGenerator';
import CustomTextInput from '../../commonComponents/customTextInput/customTextInput';
import { EmailValidation } from '../../helpers/validation';
import { types } from '../../redux/actionTypes';
import { tdsActions } from './tdsRedux/tds.actions';
import Modal  from "react-native-modal";
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import { useTheme } from '@emotion/react';
import { ODSInput } from '../../../openbrix-design-system/ui/atoms/ODSInput';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton/index.native';
import { ODSModal } from '../../../openbrix-design-system/ui/atoms/ODSModal/ODSModal.web';

const custodialActivation = (props) => {
  const dispatch = useDispatch();
  const layoutType = getPlatformType();
  const [type, setType] = useState('web');
  const [isSFUser, setIsSFUser] = useState(null);
  const {colors}=useTheme();

  const [state, setState] = useState({
    email: '',
    activation_code: '',
    resendEmail: '',
    captchaToken:"",
    last_name:"",
    last_name:"",
  });
  const [sentModal, setModal] = useState(false);

  useEffect(() => {
    if (props?.route?.params?.isSFUser=="Yes") {
      setIsSFUser(props?.route?.params?.isSFUser);
    } else {
      setIsSFUser(null);
    }
  }, [props?.route?.params?.isSFUser]);

  const resendActivationLink = () => {
    navigateAction(props?.navigation, 'TDS Create Password');
  };
  const activateNow = () => {
    const emailValidate = EmailValidation(state?.email);
    if (emailValidate?.status) {
      if (state?.activation_code != '') {
        let payload = {
          email: state?.email.trim(),
          activation_code: state?.activation_code.trim(),
        };
        dispatch(
          tdsActions.activateEmail(
            payload,
            (e) => {
              dispatch({
                type: types.SHOW_ALERT,
                alertType: 'success',
                text: 'Activate successfully',
              });
              navigateAction(props?.navigation, 'TDS Create Password', {
                email: state?.email.trim(),
                activation_code: state?.activation_code.trim(),
              });
            },
            isSFUser
          )
        );
      } else {
        dispatch({
          type: types.SHOW_ALERT,
          alertType: 'error',
          text: 'Invalid activation code',
        });
      }
    } else {
      dispatch({
        type: types.SHOW_ALERT,
        alertType: 'error',
        text: 'Invalid email',
      });
    }
  };
  const activateNowSf = () => {
    const emailValidate = EmailValidation(state?.email);

    if (state?.captchaToken) {
    if (emailValidate?.status) {
      if (state?.last_name) {
      if (state?.first_name) {
      if (state?.activation_code != '') {
        let payload = {
          email: state?.email.trim(),
          password: state?.activation_code.trim(),
          first_name:state.first_name,
          last_name:state.last_name,
          recaptcha:state.captchaToken
        };
        dispatch(
          tdsActions.activateEmail(
            payload,
            (e) => {
              dispatch({
                type: types.SHOW_ALERT,
                alertType: 'success',
                text: 'Activate successfully',
              });
              navigateAction(props?.navigation, 'TDS Create Password', {
                email: state?.email.trim(),
                activation_code: state?.activation_code.trim(),
              });
            },
            isSFUser
          )
        );
      } else {
        dispatch({
          type: types.SHOW_ALERT,
          alertType: 'error',
          text: 'Invalid activation code',
        });
      }
    }else {
      dispatch({
        type: types.SHOW_ALERT,
        alertType: 'error',
        text: 'Please enter first name',
      });
    }}else {
      dispatch({
        type: types.SHOW_ALERT,
        alertType: 'error',
        text: 'Please enter last name',
      });
    }
    } else {
      dispatch({
        type: types.SHOW_ALERT,
        alertType: 'error',
        text: 'Invalid email',
      });
    }}else{
      dispatch({
        type: types.SHOW_ALERT,
        alertType: 'error',
        text: 'Please validate recaptcha first!',
      });
    }
  };
  const resendCode = () => {
    const emailValidate = EmailValidation(state?.resendEmail);
   if(state?.captchaToken){
    if (emailValidate?.status) {
      let payload = {
        email: state?.resendEmail.trim(),
        recaptcha:state?.captchaToken
      };
      dispatch(
        tdsActions.sendActivationCode(
          payload,
          (e) => {
            setModal(true);
          },
          isSFUser
        )
      );
    } else {
      dispatch({
        type: types.SHOW_ALERT,
        alertType: 'error',
        text: 'Invalid email',
      });
    }
   }else{
      dispatch({
        type: types.SHOW_ALERT,
        alertType: 'error',
        text: 'Please validate recaptcha first!',
      });
   }
  
  };
  const resendCodeWithoutCaptch = () => {
    const emailValidate = EmailValidation(state?.resendEmail);
 
    if (emailValidate?.status) {
      let payload = {
        email: state?.resendEmail.trim(),
      };
      dispatch(
        tdsActions.sendActivationCode(
          payload,
          (e) => {
            setModal(true);
          },
          isSFUser
        )
      );
    } else {
      dispatch({
        type: types.SHOW_ALERT,
        alertType: 'error',
        text: 'Invalid email',
      });
    }
   }

  const handleChange = (value, field) => {
    setState({ ...state, [field]: value });
  };
  const handleOnChange = (value) => {
    setState({
      ...state,
      recaptchaValue: true,
      captchaToken: value,
    });
  };
  const renderBoxSection = () => {
    return (
      <View
        style={{
          width: '100%',
          flexDirection: layoutType == 'phone' ? 'column' : 'row',
          marginTop: 50,
          marginBottom: 50,
          justifyContent: 'space-between',
          alignSelf: 'center',
        }}
      >
        <View style={layoutType == 'phone' ? {} : { marginRight: 8, flex: 0.5 }}>
        <BoxShadow
          bottom={'30px'}
          
        >
          <View style={{width:'100%',borderRadius:19,borderWidth:2,borderColor:'#62D6A0',backgroundColor:'#DFFFF0',height:90,justifyContent:'center',alignItems:'center'}}>
            <ODSText type='md-bold' color={colors.text.primary}>Please activate your account</ODSText>
          </View>
          <ODSText marginTop={40} textAlign='center' type='md-bold' color={colors.text.primary}>
          Do you have an activation code?
          </ODSText>
          <ODSText marginTop={16} marginBottom={32} textAlign='center' type='sm' color={colors.text.primary}>
          {`You will have received an activation email at the start of your tenancy from TDS. This will allow you to create your password so that you can log into your account and manage your deposit.

Please enter your email address and activation code below to activate your account. You will then be asked to create a password for your TDS account`}
          </ODSText>

          {isSFUser =='Yes'? (
            <>
<ODSInput
        placeholder='First Name'
        onChange={(value) => handleChange(value, 'first_name')}
        />
         <ODSInput
        placeholder='Last Name'
        onChange={(value) => handleChange(value, 'last_name')}
        />
              {/* <CustomTextInput
                id="first_name"
                width={'100%'}
                placeHolder="First Name"
                type="text"
                name="first_name"
                // prefilledValue={state?.activation_code}
                bColor={'#638ACC'}
                onChangeText={(value) => handleChange(value, 'first_name')}
              />
              <CustomTextInput
                id="last_name"
                width={'100%'}
                placeHolder="Last Name"
                type="text"
                name="last_name"
                // prefilledValue={state?.activation_code}
                bColor={'#638ACC'}
                onChangeText={(value) => handleChange(value, 'last_name')}
              /> */}
            </>
          ) : null}
           <ODSInput
        placeholder='Email'
        onChange={(value) => handleChange(value, 'email')}
        />
         <ODSInput
        placeholder='Activation Code'
        onChange={(value) => handleChange(value, 'activation_code')}
        />
          {/* <CustomTextInput
            id="Email"
            width={'100%'}
            placeHolder="Email"
            type="text"
            name="email"
            // prefilledValue={state?.email}
            bColor={'#638ACC'}
            onChangeText={(value) => handleChange(value, 'email')}
          />
          <CustomTextInput
            id="activationCode"
            width={'100%'}
            placeHolder="Activation Code"
            type="text"
            name="activationCode"
            // prefilledValue={state?.activation_code}
            bColor={'#638ACC'}
            onChangeText={(value) => handleChange(value, 'activation_code')}
          /> */}

          {/* <Typography bottom={'30px'} top={'30px'} color={'#454545'} size={'20px'} bold={400}>
            If you have any queries please{' '}
            <Typography
              onPress={() => window.open(Constant.TDS_CONTACTUS, '_blank')}
              color={'#2052A6'}
              size={'20px'}
              bold={800}
            >
              {' '}
              click here{' '}
            </Typography>
            to contact us.
          </Typography> */}
          {isSFUser=="Yes" ? (
            <View
              style={{
                paddingTop: 20,
                alignItems: 'center',
              }}
            >
              <ReCAPTCHA
                id={'register-recaptcha'}
                sitekey={Constant.RECAPTCHA_KEY}
                onChange={handleOnChange}
              />
            </View>
          ) : null}
            <ODSButton
      restStyle={{width:'70%',marginTop: 32,backgroundColor:'#FF41C0',height:44,alignSelf:'center'}}
      txtSize={16}
      onPress={() => isSFUser =='Yes'?activateNowSf(): activateNow()}
      >
       Activate
       </ODSButton>
          {/* <ButtonWrapper
            color={'#659B63'}
            bcolor={'#659B63'}
            width={'100%'}
            style={{ marginTop: 30 }}
            onPress={() => isSFUser =='Yes'?activateNowSf(): activateNow()}
          >
            <Typography color={'#FFFFFF'} size={'19px'} bold={700}>
              ACTIVATE
            </Typography>
          </ButtonWrapper> */}
        </BoxShadow>
        </View>
        <View style={layoutType == 'phone' ? {} : { marginLeft: 8, flex: 0.5 }}>
        <BoxShadow
          bottom={'30px'}
        >
         <ODSText textAlign='center' type='md-bold' color={colors.text.primary}>
         Don’t have a code?
          </ODSText>
          <ODSText marginTop={16} marginBottom={16} textAlign='center' type='sm' color={colors.text.primary}>If you have not received your activation email, or the link has expired, please enter your email below and click the resend the activation link. If you have any queries, please <TouchableOpacity onPress={() => window.open(Constant.TDS_CONTACTUS, '_blank')}><ODSText color={'#001A96'} type='sm'>click here </ODSText> </TouchableOpacity>to contact us.</ODSText>
          <ODSInput
        placeholder='Email'
        onChange={(value) => handleChange(value, 'resendEmail')}
        />
          {isSFUser=="Yes" ? (
            <View
              style={{
                paddingTop: 20,
                alignItems: 'center',
              }}
            >
              <ReCAPTCHA
                id={'register-recaptcha'}
                sitekey={Constant.RECAPTCHA_KEY}
                onChange={handleOnChange}
              />
            </View>
          ) : null}
         <ODSButton
      restStyle={{width:'70%',marginTop: 32,backgroundColor:'#FF41C0',height:44,alignSelf:'center'}}
      txtSize={16}
      onPress={() => isSFUser=="Yes" ?resendCode(): resendCodeWithoutCaptch() }
      >
       Resend Activation Email
       </ODSButton>
       <ODSText type='xs' color={colors.text.primary} textAlign='center' marginTop={8}>The email may take a few minutes to arrive, please check your spam/trash folder before re-sending</ODSText>

          {/* <Typography top={'20px'} color={'#0000002'} size={'23px'} bold={700}>
            Resend Activation Code
          </Typography>
          <Typography top={'30px'} color={'#454545'} size={'20px'} bold={400}>
            If you have not received your activation code, or the link has expired, please enter the
            email used with your TDS account and click resend.{' '}
          </Typography>
          <Typography bottom={'100px'} top={'30px'} color={'#454545'} size={'20px'} bold={400}>
            If you have any queries please{' '}
            <Typography
              onPress={() => window.open(Constant.TDS_CONTACTUS, '_blank')}
              color={'#2052A6'}
              size={'20px'}
              bold={800}
            >
              click here{' '}
            </Typography>
            to contact us.
          </Typography>

          <CustomTextInput
            id="resendEmail"
            width={'100%'}
            placeHolder="Email"
            type="text"
            name="resendEmail"
            // prefilledValue={state?.resendEmail}
            bColor={'#638ACC'}
            onChangeText={(value) => handleChange(value, 'resendEmail')}
          /> */}
         
          {/* <ButtonWrapper
            color={'#659B63'}
            bcolor={'#659B63'}
            width={'100%'}
            style={{ marginTop: 30 }}
            onPress={() => isSFUser=="Yes" ?resendCode(): resendCodeWithoutCaptch() }
          >
            <Typography color={'#FFFFFF'} size={'19px'} bold={700}>
              RESEND ACTIVATION EMAIL
            </Typography>
          </ButtonWrapper> */}
        </BoxShadow>
        </View>
      </View>
    );
  };

  return (
    <>
      <BackGroundGenerator
        infoIcon
        isTds
        paddingtop={80}
        isBack={true}
        props={props}
        layoutType={(data) => {
          setType(data);
        }}
        isTLYF
        backgroundArr={backgroundTdsArrBackPage}
        backNavigation={() => popAction(props.navigation, 'TDS Search Deposit')}
      >
        <Container width={'1080px'}>

          {renderBoxSection()}
          <ODSModal
            visible={sentModal}
            transparent={true}
            coverScreen={false}
            hasBackdrop={false}
            backdropOpacity={0}
            onBackdropPress={() => setModal(false)}
            style={{ margin: 0, width: '100%', flex: 1, backgroundColor: '#00000080' }}
          >
            <View
              style={{
                width: layoutType == 'phone' ? '95%' : '40%',
                backgroundColor: '#FAFAFA',
                borderRadius: 20,
                overflow: 'hidden',
                alignSelf: 'center',
                padding: layoutType == 'phone' ? 30 : 40,
              }}
            >
             
              <View style={{width:'100%',borderRadius:19,borderWidth:2,borderColor:'#62D6A0',backgroundColor:'#DFFFF0',height:90,justifyContent:'center',alignItems:'center'}}>
            <ODSText type='md-bold' color={colors.text.primary}>Activation email sent</ODSText>
          </View>
          <ODSText color={colors.text.primary} marginTop={48} type='sm' textAlign='center'>If we have found an account you will have been emailed an activation code. Once you have received the activate code you can return here to activate your account.</ODSText>
          <ODSText color={colors.text.primary} type='sm' marginTop={8} textAlign='center'>If you do not receive an email please<TouchableOpacity onPress={() => window.open(Constant.TDS_CONTACTUS, '_blank')} ><ODSText type='sm' color='#001A96'> contact us</ODSText></TouchableOpacity></ODSText>
          <ODSButton
      restStyle={{width:'50%',marginTop: 32,backgroundColor:'#FF41C0',height:44,alignSelf:'center'}}
      txtSize={16}
      onPress={() => setModal(false)}
      >
       Back to activation 
       </ODSButton>
              {/* <Typography top={'80px'} color={'#454545'} size={'20px'} bold={400} text>
                Please check email for the activation code.{'\n'}
                Once you have received this you can return here to activate your account.{'\n'}
                If you have not received an email please{' '}
                <Typography
                  onPress={() => window.open(Constant.TDS_CONTACTUS, '_blank')}
                  color={'#2052A6'}
                  size={'20px'}
                  bold={800}
                >
                  contact us.
                </Typography>
              </Typography>
              <ButtonWrapper
                width={layoutType == 'phone' ? '60%' : '30%'}
                style={{ marginTop: 80 }}
                onPress={() => setModal(false)}
              >
                <Typography color={'#FFFFFF'} size={'19px'} bold={700}>
                  BACK
                </Typography>
              </ButtonWrapper> */}
            </View>
          </ODSModal>
        </Container>
      </BackGroundGenerator>
    </>
  );
};

export default custodialActivation;
